<template>
  <div id="floatRateTrip">
    <div class="bg-brand-500 fw-600 brand-950">
      <div class="container flex flex-wrap justify-between items-center py-8 mb-py-20">
        <div class="mb-mb-16 relative">Thank you for traveling with Designer Journeys. How was your trip with us?</div>
        <router-link id="button-bookable-trip-plan-top-rate-trip" :to="{ name: 'feedback', params: { id: dataTrip.id, point: 9 } }">
          <DJButton size="small">Rate my trip</DJButton>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import DJButton from '~/components/ui/button/Button.vue'
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
</script>

<style lang="scss" scoped></style>
